import React from 'react'
import { connect } from 'formik'
import { getObjectLabels } from '@paintscout/util/builder'
import { Grid, Typography } from '@paintscout/ui'
import { useClientOptions } from '@paintscout/ui-business'
import type {
  PresentationSectionFormProps,
  FormikPresentationSectionConnectProps,
  FormikPresentationSectionValues
} from '../../'

const TermsForm = (_: PresentationSectionFormProps & FormikPresentationSectionConnectProps) => {
  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options })

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography>This section will show the Contract Terms of your {objectLabels.quote.value}</Typography>
      </Grid>
    </Grid>
  )
}
export default connect<PresentationSectionFormProps, FormikPresentationSectionValues>(TermsForm)
